import { render, staticRenderFns } from "./OpenPeriods.vue?vue&type=template&id=982b1d02&"
import script from "./OpenPeriods.vue?vue&type=script&lang=ts&"
export * from "./OpenPeriods.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports